import { getRouteApi } from '@tanstack/react-router'
import { useCallback } from 'react'
import { z } from 'zod'

import { PUPPET_TABS, PuppetsPage, type PuppetTab } from '@/features/puppets/PuppetsPage'

/** `/puppets?tab=people|animals|birds|sea|props|mine&q=` (docs/SKEL-STORY.md P8). */
const lenient = <T extends z.ZodTypeAny>(schema: T) => schema.optional().catch(undefined)

export const puppetsSearchSchema = z.object({
  tab: lenient(z.enum(PUPPET_TABS)),
  q: lenient(z.string().max(80)),
})
export type PuppetsSearch = z.infer<typeof puppetsSearchSchema>

export function validatePuppetsSearch(input: Record<string, unknown>): PuppetsSearch {
  return puppetsSearchSchema.parse(input)
}

const route = getRouteApi('/puppets')

export function PuppetsRoutePage() {
  const search = route.useSearch()
  const navigate = route.useNavigate()
  const onSearchChange = useCallback((next: { tab?: PuppetTab; q?: string }) => void navigate({ search: next, replace: true }), [navigate])
  return <PuppetsPage tab={search.tab} q={search.q ?? ''} onSearchChange={onSearchChange} />
}
